import { HStack, chakra } from "@chakra-ui/react";

export const NoVenueBanner = ({
  show,
  type,
}: {
  show: boolean;
  type: "tickettype" | "timeline";
}) => {
  if (!show) return null;

  const message = {
    tickettype: "to start creating ticket types.",
    timeline: "to set the event timeline.",
  };
  const needs = {
    tickettype: "timelines",
    timeline: "venue",
  };

  return (
    <HStack
      w="full"
      p={4}
      mt={4}
      bgColor="#fafafa"
      borderRadius={"md"}
      justifyContent={"center"}
    >
      <chakra.span>Please </chakra.span>
      <chakra.span fontWeight={"bold"}>set the {needs[type]}</chakra.span>
      <chakra.span>{message[type]}</chakra.span>
    </HStack>
  );
};
